var map = {
	"./audio01_1.mp3": 1082,
	"./audio01_2.mp3": 3946,
	"./audio02_1.mp3": 8558,
	"./audio02_2.mp3": 8017,
	"./audio03_1.mp3": 7947,
	"./audio03_2.mp3": 980,
	"./audio04_1.mp3": 5660,
	"./audio04_2.mp3": 6035,
	"./audio05_1.mp3": 3065,
	"./audio05_2.mp3": 7142,
	"./audio06_1.mp3": 8714,
	"./audio06_2.mp3": 1613,
	"./audio07_1.mp3": 2583,
	"./audio07_2.mp3": 3744,
	"./audio08_1.mp3": 72,
	"./audio08_2.mp3": 3743,
	"./audio09_1.mp3": 4549,
	"./audio09_2.mp3": 4597,
	"./audio10_1.mp3": 8075,
	"./audio10_2.mp3": 4756,
	"./audio11_1.mp3": 494,
	"./audio11_2.mp3": 6433,
	"./audio12_1.mp3": 9418,
	"./audio12_2.mp3": 1866,
	"./audio13_1.mp3": 6464,
	"./audio13_2.mp3": 1399,
	"./audio14_1.mp3": 2871,
	"./audio14_2.mp3": 4704,
	"./audio15_1.mp3": 4842,
	"./audio15_2.mp3": 6573,
	"./audio16_1.mp3": 5881,
	"./audio16_2.mp3": 3926,
	"./audio17_1.mp3": 4716,
	"./audio17_2.mp3": 2531,
	"./audio18_1.mp3": 2275,
	"./audio18_2.mp3": 5548,
	"./audio19_1.mp3": 3318,
	"./audio19_2.mp3": 2745,
	"./audio20_1.mp3": 3338,
	"./audio20_2.mp3": 4861,
	"./audio21_1.mp3": 8455,
	"./audio21_2.mp3": 1680,
	"./audio22_1.mp3": 2060,
	"./audio22_2.mp3": 3395,
	"./audio23_1.mp3": 7193,
	"./audio23_2.mp3": 9830,
	"./audio24_1.mp3": 7406,
	"./audio24_2.mp3": 9841,
	"./audio25_1.mp3": 2395,
	"./audio25_2.mp3": 1668,
	"./audio26_1.mp3": 4544,
	"./audio26_2.mp3": 3383,
	"./audio27_1.mp3": 7133,
	"./audio27_2.mp3": 9130,
	"./audio28_1.mp3": 4994,
	"./audio28_2.mp3": 1906,
	"./audio29_1.mp3": 2479,
	"./audio29_2.mp3": 8808,
	"./audio30_1.mp3": 3621,
	"./audio30_2.mp3": 6050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4672;